import React, { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";

function Input(props) {
  //for sorting dropdown items alphabetical

  const [dropdownItem, setDropdownItem] = useState(props.options);

  useEffect(() => {
    setDropdownItem(props.options);
  }, [props.options]);
  useEffect(() => {
    const sortedDropdownItem = [...dropdownItem].sort((a, b) =>
      a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1
    );

    setDropdownItem(sortedDropdownItem);
  }, []);

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,

      borderColor: "#ed6c306b",
      outline: "none",
      "&:hover": {
        borderColor: "#ed6c306b",
      },
      "&:focus": {
        outline: "none",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "0.8rem",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "0.8rem",
    }),
    menu: (provided, state) => ({
      ...provided,
      fontSize: "0.8rem",
    }),
  };
  if (props.type === "text") {
    return (
      <div className={`${props.CustomInputStyle} relative mb-4 flex flex-col`}>
        <label
          className={`${props.labelStyle} font-medium text-textblack mb-1 text-sm md:text-base`}
        >
          {props.Name} {props.isRequired && <span className="text-red">*</span>}
        </label>

        <input
          name={props.valueLabel}
          onChange={(e) =>
            props.onInputChangeHandler(
              e.target.name,
              e.target.value,
              props.index
            )
          }
          value={props.value}
          className={`${props.inputStyle}  py-2 px-1 w-full border-[1px] border-btnbgcolorlight text-lightgrey rounded text-xs md:text-sm`}
          type="text"
          placeholder={props.placeholder}
          required={props.isRequired}
        />
        {props.errorMsg ? (
          <span className="absolute top-[100%] left-0 block w-full mt-[0.01rem] text-red text-[0.5rem] md:text-[0.7rem] ">
            {props.errorMsg}
          </span>
        ) : (
          <span className="absolute  top-[100%] left-0 block w-full text-red  text-[0.5rem] md:text-[0.7rem] ">
            &#160;{" "}
          </span>
        )}
      </div>
    );
  } else if (props.type === "date") {
    return (
      <div className={`${props.CustomInputStyle} relative mb-4 flex flex-col`}>
        <label className="font-medium text-textblack mb-1 text-sm md:text-base">
          {props.Name} {props.isRequired && <span className="text-red">*</span>}
        </label>
        <input
          name={props.valueLabel}
          onChange={(e) =>
            props.onInputChangeHandler(
              e.target.name,
              e.target.value,
              props.index
            )
          }
          value={props.value}
          className={`${props.inputStyle}  py-2 px-1 w-full border-[1px] border-btnbgcolorlight text-lightgrey rounded text-xs md:text-sm`}
          type="date"
          placeholder={props.placeholder}
          required={props.isRequired}
        />
        {props.errorMsg ? (
          <span className="absolute top-[100%] left-0 block w-full mt-[0.01rem] text-red text-[0.5rem] md:text-[0.7rem] ">
            {props.errorMsg}
          </span>
        ) : (
          <span className="absolute  top-[100%] left-0 block w-full text-red  text-[0.5rem] md:text-[0.7rem] ">
            &#160;{" "}
          </span>
        )}
      </div>
    );
  } else if (props.type === "email") {
    return (
      <div className={`${props.CustomInputStyle} relative mb-4 flex flex-col`}>
        <label
          className={`${props.labelStyle} font-medium text-textblack mb-1 text-sm md:text-base`}
        >
          {props.Name} {props.isRequired && <span className="text-red">*</span>}
        </label>
        <input
          name={props.valueLabel}
          onChange={(e) =>
            props.onInputChangeHandler(
              e.target.name,
              e.target.value,
              props.index
            )
          }
          value={props.value}
          className="py-2 px-1 border-[1px] border-btnbgcolorlight text-lightgrey rounded text-xs md:text-sm"
          type="email"
          placeholder={props.placeholder}
          required={props.isRequired}
        />
        {props.errorMsg ? (
          <span className="absolute top-[100%] left-0 block w-full mt-[0.01rem] text-red text-[0.5rem] md:text-[0.7rem] ">
            {props.errorMsg}
          </span>
        ) : (
          <span className="absolute  top-[100%] left-0 block w-full text-red  text-[0.5rem] md:text-[0.7rem] ">
            &#160;{" "}
          </span>
        )}
      </div>
    );
  } else if (props.type === "number") {
    return (
      <div className={`${props.CustomInputStyle} relative mb-4 flex flex-col`}>
        <label
          className={`${props.labelStyle} font-medium text-textblack mb-1 text-sm md:text-base`}
        >
          {props.Name} {props.isRequired && <span className="text-red">*</span>}
        </label>
        <input
          name={props.valueLabel}
          onChange={(e) =>
            props.onInputChangeHandler(
              e.target.name,
              e.target.value,
              props.index
            )
          }
          value={props.value} //commint
          className={`${props.inputStyle}  py-2 px-1 w-full border-[1px] border-btnbgcolorlight text-lightgrey rounded text-xs md:text-sm`}
          type="number"
          placeholder={props.placeholder}
          required={props.isRequired}
        />
        {props.errorMsg ? (
          <span className="absolute top-[100%] left-0 block w-full mt-[0.01rem] text-red text-[0.5rem] md:text-[0.7rem] ">
            {props.errorMsg}
          </span>
        ) : (
          <span className="absolute  top-[100%] left-0 block w-full text-red  text-[0.5rem] md:text-[0.7rem] ">
            &#160;{" "}
          </span>
        )}
      </div>
    );
  } else if (props.type === "select") {
    return (
      <div
        className={`${props.CustomInputStyle} relative mb-4   inline-block  `}
      >
        <label
          className={`${props.labelStyle} font-medium block text-textblack mb-1 text-sm md:text-base`}
        >
          {props.Name} {props.isRequired && <span className="text-red">*</span>}
        </label>
        <Select
          value={props.value}
          options={dropdownItem}
          onChange={(e) => props.onInputChangeHandler(e.type, e, props.index)}
          isSearchable={true}
          placeholder={`Select`}
          styles={customSelectStyles}
        />
        {/* <select onChange={props.onInputChangeHandler} value={props.value.value} styles={customSelectStyles} >
        {dropdownItem.map(item=>{
          return <option value={item.lable}>{item.label}</option>
        })}
        </select> */}

        {props.errorMsg ? (
          <span className="absolute top-[100%] left-0 block w-full mt-[0.01rem] text-red text-[0.5rem] md:text-[0.7rem] ">
            {props.errorMsg}
          </span>
        ) : (
          <span className="absolute  top-[100%] left-0 block w-full text-red  text-[0.5rem] md:text-[0.7rem] ">
            &#160;{" "}
          </span>
        )}
      </div>
    );
  } else if (props.type === "password") {
    return (
      <div className={`${props.CustomInputStyle} relative mb-4 flex flex-col`}>
        <label
          className={`${props.labelStyle} font-medium text-textblack mb-1 text-sm md:text-base`}
        >
          {props.Name} {props.isRequired && <span className="text-red">*</span>}
        </label>
        <input
          name={props.valueLabel}
          onChange={(e) =>
            props.onInputChangeHandler(
              e.target.name,
              e.target.value,
              props.index
            )
          }
          value={props.value}
          className="py-2 px-1 border-[1px] border-btnbgcolorlight text-lightgrey rounded text-xs md:text-sm"
          type="password"
          placeholder={props.placeholder}
          required={props.isRequired}
        />
        {props.errorMsg ? (
          <span className="absolute top-[100%] left-0 block w-full mt-[0.01rem] text-red text-[0.5rem] md:text-[0.7rem] ">
            {props.errorMsg}
          </span>
        ) : (
          <span className="absolute  top-[100%] left-0 block w-full text-red  text-[0.5rem] md:text-[0.7rem] ">
            &#160;{" "}
          </span>
        )}
      </div>
    );
  } else if (props.type === "file") {
    return (
      <div
        className={`${props.CustomInputStyle} relative mb-4 flex flex-col mt-3`}
      >
        <label
          htmlFor="avatar"
          className={`${props.labelStyle} font-medium border-[1px] border-btnbgcolorlight  hover:bg-btnbgcolor hover:text-bgwhite transition duration-150 rounded cursor-pointer text-center py-2 text-textblack mb-1 text-sm md:text-base`}
        >
          {props.Name} {props.isRequired && <span className="text-red">*</span>}
        </label>
        <input
          name={props.valueLabel}
          onChange={(e) => {
            return props.onInputChangeHandler(
              e.target.name,
              e.target.files[0],
              props.index
            );
          }}
          className="py-2 px-1 border-[1px] hidden border-btnbgcolorlight text-lightgrey rounded text-xs md:text-sm"
          type="file"
          accept="image/*,.pdf"
          placeholder={props.placeholder}
          required={props.isRequired}
          id="avatar"
        />
        <p className="text-[0.6rem] text-textgreen text-center">
          {props.value.name}
        </p>
      </div>
    );
  }
}

export default Input;
